import React from "react";
import { motion } from "framer-motion";
import { useT } from "../../i18n";

const IMG =
  "https://images.unsplash.com/photo-1590083666832-03a4c0c65214?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export default function Editorial() {
  const { t } = useT();
  return (
    <section
      id="editorial"
      className="py-24 md:py-36 bg-[#f6f4ee]"
      data-testid="editorial-section"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
          className="max-w-2xl"
        >
          <div className="eyebrow mb-6">{t("editorial.sectionLabel")}</div>
          <h2 className="font-serif text-[#1a211c] tracking-tight leading-[1.05] text-[clamp(2rem,5vw,4.2rem)]">
            {t("editorial.title")}
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            className="lg:col-span-5"
          >
            <div className="relative rounded-sm overflow-hidden aspect-[4/5] bg-[#1a211c]">
              <img
                src={IMG}
                alt="Argentine high-rise architecture"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute bottom-0 inset-x-0 p-5 flex items-end justify-between text-[#f6f4ee]">
                <span className="text-[0.7rem] font-mono tracking-[0.28em]">PALERMO · CABA</span>
                <span className="text-[0.7rem] font-mono tracking-[0.28em]">A / 04</span>
              </div>
            </div>

            <div className="mt-8 border-l-2 border-[#3d4f42] pl-5">
              <p className="font-serif italic text-[#1a211c] text-2xl md:text-3xl leading-snug">
                “{t("editorial.pull")}”
              </p>
            </div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.15 }}
            variants={fadeUp}
            className="lg:col-span-7 space-y-6 text-[1.02rem] md:text-[1.08rem] leading-relaxed text-[#1a211c]/85"
          >
            <p>{t("editorial.p1")}</p>
            <p>{t("editorial.p2")}</p>
            <div className="hairline my-2" />
            <p>{t("editorial.p3")}</p>
            <p>{t("editorial.p4")}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
